/**
 * An AbortSignal that aborts with a `TimeoutError` after `ms`, or as soon as `parent` aborts.
 * Hand-rolled instead of `AbortSignal.any` + `AbortSignal.timeout`: `any` needs Chrome 116 /
 * Safari 17.4, and on older browsers it would throw before the request is even sent.
 */
export const timeoutSignal = (ms: number, parent?: AbortSignal): AbortSignal => {
  const controller = new AbortController();
  const timer = setTimeout(
    () => controller.abort(new DOMException(`Request timed out after ${ms / 1000}s`, 'TimeoutError')),
    ms,
  );
  const onParentAbort = () => controller.abort(parent?.reason);

  if (parent?.aborted) onParentAbort();
  else parent?.addEventListener('abort', onParentAbort, { once: true });

  // Whichever fires first, release the other so a finished request leaves nothing pending.
  controller.signal.addEventListener(
    'abort',
    () => {
      clearTimeout(timer);
      parent?.removeEventListener('abort', onParentAbort);
    },
    { once: true },
  );
  return controller.signal;
};
